import React, { useEffect, useState } from "react";
import { getActivity } from "@/lib/api";
import { PageHeader } from "@/pages/admin/AdminDashboard";

export default function AdminActivity() {
  const [rows, setRows] = useState([]);
  useEffect(() => { getActivity(500).then(setRows); }, []);
  return (
    <div data-testid="admin-activity-page">
      <PageHeader eyebrow="Audit" title="Activity History" note="Every editorial action is recorded here." />
      <div className="mt-8 border bg-white" style={{ borderColor: "var(--gi-border)" }}>
        <div className="grid grid-cols-[200px_140px_120px_1fr_180px] gap-4 px-5 py-3 border-b text-[10px] font-accent" style={{ borderColor: "var(--gi-border)", color: "var(--gi-muted)", letterSpacing: "0.14em" }}>
          <div>When</div><div>Actor</div><div>Action</div><div>Entity</div><div>Details</div>
        </div>
        {rows.length === 0 && <div className="p-8 text-sm text-center" style={{ color: "var(--gi-muted)" }}>No activity yet.</div>}
        {rows.map(r => (
          <div key={r.id} className="grid grid-cols-[200px_140px_120px_1fr_180px] gap-4 px-5 py-3 border-b last:border-b-0 text-sm items-center" style={{ borderColor: "var(--gi-divider)" }} data-testid={`activity-row-${r.id}`}>
            <div className="text-xs" style={{ color: "var(--gi-muted)" }}>{new Date(r.timestamp).toLocaleString()}</div>
            <div className="text-xs">{r.actor_email}</div>
            <div className="text-xs uppercase tracking-[0.14em]">{r.action}</div>
            <div className="text-sm"><em style={{ color: "var(--gi-muted)" }}>{r.entity_type}</em> {r.entity_title || r.entity_id}</div>
            <div className="text-xs" style={{ color: "var(--gi-muted)" }}>{r.actor_role}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
